/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { BurgerMenu } from './components';
import MenuList from './components/MenuList';

function HeaderMobile({ routes }) {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const burgerRef = useRef();

  useEffect(() => {
    document.body.style.overflowY = isOpenMenu ? 'hidden' : '';
  }, [isOpenMenu]);

  const handleBackdropClick = () => {
    setIsOpenMenu(false);
  };

  return (
    <Styled.Wrapper>
      <BurgerMenu innerRef={burgerRef} open={isOpenMenu} setOpen={setIsOpenMenu} />
      {isOpenMenu && <Styled.Backdrop onClick={handleBackdropClick} />}
      <Styled.Body isOpenMenu={isOpenMenu}>
        {isOpenMenu && (
          <MenuList isOpenMenu={isOpenMenu} routes={routes} setIsOpenMenu={setIsOpenMenu} burgerRef={burgerRef} />
        )}
      </Styled.Body>
    </Styled.Wrapper>
  );
}

HeaderMobile.propTypes = {
  routes: PropTypes.array.isRequired,
};

export default HeaderMobile;
